import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

const RESOURCE = "/address/lookup";

export interface AddressLookupData {
  street: string;
  neighborhood: string;
  city: string;
  state: string;
}

export const lookupAddressByPostalCode = (
  postalCode: string
): Promise<ApiResponse<AddressLookupData>> =>
  api.get<ApiResponse<AddressLookupData>>(RESOURCE, { postal_code: postalCode });
